import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as Types from '../types';
function createDefaultState() {
    return {
        overlay: { type: Types.OverlayType.Null },
        dialog: Types.SettingsTabs.None,
        placeHolders: {},
    };
}
export const ScreenContext = React.createContext({
    ...createDefaultState(),
    setScreen: () => { },
});
ScreenContext.displayName = 'ScreenContext';
export function ScreenStateProvider(props) {
    const [state, setState] = React.useState(createDefaultState());
    return (_jsx(ScreenContext.Provider, { value: { ...state, setScreen: setState }, children: props.children }));
}
export function useSettingsDialog() {
    const context = React.useContext(ScreenContext);
    return {
        tab: context.dialog,
        setTab: (tab) => {
            const newValue = {
                dialog: tab,
                overlay: context.overlay,
                placeHolders: context.placeHolders,
            };
            context.setScreen(newValue);
        },
    };
}
export function useOverlay() {
    const context = React.useContext(ScreenContext);
    return {
        overlay: context.overlay,
        setOverlay: overlay => {
            const newValue = {
                dialog: context.dialog,
                overlay: overlay,
                placeHolders: context.placeHolders,
            };
            context.setScreen(newValue);
        },
    };
}
function setPlaceHolder(context, name, value, id) {
    const newValue = { ...context };
    if (!newValue.placeHolders[name]) {
        newValue.placeHolders[name] = {};
    }
    if (id === undefined) {
        id = 'default';
    }
    newValue.placeHolders[name][id] = value;
    context.setScreen(newValue);
}
export function ModuleNav(props) {
    return SetPlaceholder({
        name: 'ModuleNav',
        children: props.children,
        id: props.id,
    });
}
export function ContextButtons(props) {
    return SetPlaceholder({
        name: 'ContextButtons',
        children: props.children,
        id: props.id,
    });
}
export function ContextTitle(props) {
    return SetPlaceholder({
        name: 'Title',
        children: props.children,
        id: props.id,
    });
}
function SetPlaceholder(props) {
    const context = React.useContext(ScreenContext);
    React.useEffect(() => {
        setPlaceHolder(context, props.name, props.children, props.id);
        return () => {
            setPlaceHolder(context, props.name, undefined, props.id);
        };
    }, [props.children]);
    return _jsx(_Fragment, {});
}
export function Placeholder(props) {
    const context = React.useContext(ScreenContext);
    const result = context.placeHolders[props.name];
    if (result === undefined) {
        return props.children;
    }
    const collection = [];
    const sortedKeys = Object.keys(result).sort();
    for (const id of sortedKeys) {
        if (result[id] !== undefined) {
            collection.push(result[id]);
        }
    }
    if (collection.length === 0) {
        return props.children;
    }
    return _jsx(_Fragment, { children: collection });
}
